import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Permission } from '../models/permission.model';
import { BaseResponse } from 'ccc-commons/dist/core';


@Injectable()
export class PermissionsService {
  apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getPermissions(): Observable<BaseResponse<Permission>> {
    return this.http.get<BaseResponse<Permission>>(this.apiUrl + '/permissions');
  }

}
